export default __webpack_public_path__ + "static/media/PUMA_MAYZE_60s_16x9_MASTER.6eef0c9f.mp4";